module.exports = __webpack_public_path__ + "static/media/validatePhoneNumber_error.155a4e20.svg";